module.exports = __webpack_public_path__ + "public/files/img/results_steps_1.ef92b996.png";